import { ActionContext } from 'vuex';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IFilterBillingPayload } from '@/shared/interfaces/billing-reports';

export default {
  namespaced: true, // 'billing-report/'

  state: {
    list: undefined,
  },

  getters: {
  },

  mutations: {

  },

  actions: {
    async getBilling(ctx: ActionContext<any, any>, payload: IFilterBillingPayload) {
      const queryOptionsKeysArray = Object.keys(payload.filterOptions);
      const queryOptionsValuesArray = Object.values(payload.filterOptions);
      const queryArray = queryOptionsKeysArray.map((key, index) => `${key}=${queryOptionsValuesArray[index]}`);
      const queryString = payload.type !== 'call_tracking' ? `?${queryArray.join('&')}` : '';
      const result = await adminRequest.get(`/billing-api/reporting/client_billing_summary/${payload.type}/${payload.date}${queryString}`);
      return result.data;
    },
  },
};
